import React from 'react';
import { makeStyles } from 'tss-react/mui';

import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';

export type Props = TooltipProps;

const useStyles = makeStyles()(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[1],
    fontSize: theme.typography.fontSize,
  },
  popper: {
    opacity: 1,
  },
}));

const TooltipNext: React.FC<TooltipProps> = ({
  children,
  classes: customClasses,
  ...rest
}) => {
  const { classes, cx } = useStyles();

  return (
    <Tooltip
      classes={{
        ...customClasses,
        tooltip: cx(classes.tooltip, customClasses?.tooltip),
        popper: cx(classes.popper, customClasses?.popper),
      }}
      enterTouchDelay={100}
      {...rest}
    >
      {children || <InfoIcon />}
    </Tooltip>
  );
};

export { TooltipNext };
